module.exports = __webpack_public_path__ + "img/candy-wing1.36f987ec.png";